<app-loader>
</app-loader>
<div class="container-fluid p-0">
    <div class="row g-0">

        <div class="col-xl-9">
            <div class="auth-full-bg pt-lg-5 p-4">

                <div class="w-100">
                    <div class="bg-overlay"></div>

                    <div class="d-flex h-100 flex-column">

                        <div class="p-4 mt-auto">
                            <div class="row justify-content-center">
                                <div class="justify-content-center">
                                    <!-- <img src="assets/images/logocompany.png" alt="" height="80" width="250"> -->
                                    <img [src]="logo_img | imagenCompany" alt=""  width="80" >
                                    <!-- <img src="assets/images/logolinker.png" alt="" height="80" width="250"> -->

                                </div>
                                <div class="col-lg-7">
                                    <div class="text-center">
                                        <h4 class="mb-3"><i class="bx bxs-quote-alt-left text-primary h1 align-middle me-3"></i><span class="text-primary">Controles</span> Volumetricos</h4>

                                        <div dir="ltr">
                                            <owl-carousel-o class="owl-theme auth-review-carousel" [options]="carouselOption">
                                                <ng-template carouselSlide>
                                                    <div class="item">
                                                        <div class="py-3">
                                                            

                                                            <div>
                                                                
                                                            </div>
                                                        </div>

                                                    </div>
                                                </ng-template>
                                               
                                            </owl-carousel-o>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- end col -->

        <div class="col-xl-3 d-flex align-items-center justify-content-center min-vh-100 bg-white">
  <div class="auth-full-page-content w-100 p-md-5 p-4">
    <div class="w-100 d-flex flex-column justify-content-center align-items-center" style="min-height: 100%;">
      
      <!-- LOGO centrado -->
      <div class="text-center mb-4">
        <img [src]="logo_img | imagenCompany"
             alt="Logo"
             width="80"
             class="auth-logo-dark mb-2">
      </div>

      <!-- FORMULARIO centrado -->
      <div class="w-100">
        <h5 class="text-primary text-center">¡Bienvenido de nuevo!</h5>
        <p class="text-muted text-center">Inicia sesión para continuar.</p>

        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="mt-4">
          <div *ngIf="showerror" class="alert alert-danger text-center" role="alert">
            {{ error }}
          </div>

          <div class="mb-3">
            <label for="email">Email</label>
            <input type="email"
                   id="email"
                   class="form-control"
                   formControlName="email"
                   [ngClass]="{ 'is-invalid': submitted && f.email.errors }"
                   placeholder="Ingresa email">
            <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
              <div *ngIf="f.email.errors.required">Email es requerido</div>
              <div *ngIf="f.email.errors.email">Email debe ser válido</div>
            </div>
          </div>

          <div class="mb-3">
            <label for="userpassword">Password</label>
            <div class="input-group">
              <input [type]="fieldTextType ? 'text' : 'password'"
                     id="userpassword"
                     class="form-control"
                     maxlength="50"
                     formControlName="password"
                     placeholder="Ingresa password"
                     [ngClass]="{ 'is-invalid': submitted && f.password.errors }">
              <button class="btn btn-light" (click)="toggleFieldTextType()" type="button">
                <i class="mdi" [ngClass]="fieldTextType ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"></i>
              </button>
              <div *ngIf="submitted && f.password.errors" class="invalid-feedback d-block">
                <span *ngIf="f.password.errors.required">Password es requerido</span>
              </div>
            </div>
          </div>

          <div class="d-grid mt-3">
            <button class="btn btn-primary" type="submit" [disabled]="isLoading">
              <i class="fa" [ngClass]="{ 'fa-spin fa-spinner': isLoading, 'fa-check': !isLoading }"></i> {{ button }}
            </button>
          </div>
        </form>
      </div>

      <!-- FOOTER -->
      <div class="mt-4 text-center">
        <img src="assets/images/volumetricos.png" height="50" width="120" class="mb-2">
        <p class="mb-0 text-muted">© {{ year }} MBQ. eSCV 1.2.1</p>
      </div>

    </div>
  </div>
</div>

   
</div>
<!-- end container-fluid -->